import { simpleSet } from '@r/reducers/utils';

const setCalculationModeProjectNumber = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.information.projectNumber;

export const projectNumber = setCalculationModeProjectNumber(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_PROJECT_NUMBER',
  ''
);
